var plugin_default = {
  "alignLeft": "-B2za",
  "textWrapNowrap": "rsLFN",
  "alignRight": "-sEKH",
  "alignCenter": "j6j2T",
  "sizeFullWidth": "AJRkc",
  "renderedInTable": "KFAT1",
  "sizeOriginal": "-NFu0",
  "sizeContent": "j72Xt",
  "sizeSmall": "_46-i0",
  "sizeSmallCenter": "ipGtE",
  "flex": "-dsXx",
  "atomic": "yIaPa",
  "embed": "HLbuc",
  "horizontalScrollbar": "_4Q7ff",
  "pluginContainerMobile": "_2YDGf"
};
export {
  plugin_default as default
};
//# sourceMappingURL=plugin-scss.js.map
